import { render } from "./LicenseChangeList.vue?vue&type=template&id=39b434d0"
import script from "./LicenseChangeList.vue?vue&type=script&lang=js"
export * from "./LicenseChangeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__